import Keycloak from 'keycloak-js';


const keycloakJsonUrl = process.env.REACT_APP_FA_KEYCLOAK_URL
const keycloak = Keycloak(keycloakJsonUrl)
export const apiHost = process.env.REACT_APP_FA_API_HOST

//  const keycloak = Keycloak('/keycloak.json'); //Local
// export const apiHost = "https://local.superlife.co.nz:443" //Dev-server & Local purpose
// const keycloak = Keycloak('/adviser/keycloak.json'); //Dev-server Purpose
// export const apiHost = "https://devappms.superlife.co.nz" //Dev-server & Local purpose
// const keycloak = Keycloak('/adviser/keycloakTest.json') //Test-server Purpose
// export const apiHost = "https://testwebms.superlife.co.nz" //Test-server pusrpose
// const keycloak = Keycloak('/adviser/keycloakUat.json'); //UAT-server Purpose
//export const apiHost = "https://uatwebms01.superlife.co.nz" //UAT-server
////const keycloak = Keycloak('/adviser/keycloakProd.json') //Prod-Server Purpose
//export const apiHost = "https://my.superlife.co.nz" //Prod-Server purpose

function authorizationHeader() {
    if(!keycloak) return {};
        return {
            headers: {
              "Authorization": "Bearer " + keycloak.token,
      
            }
        };    
}

export function loginToKeycloak(){
    return (dispatch) => {
        return keycloak.init({onLoad: 'login-required'}).then((authenticated) => {
            dispatch(keycloakLogin(keycloak, authenticated))
        })
    }
    
}
export function startLoadingAdvisers(){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getAdviser`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json();
                else 
                    return{status: response.status, message: response.statusText}
            })
            .then(response => dispatch(getAdvisers(response.advisers, response.total, response.groupLogin, response.lastLoginDate)))
            .catch(err => console.log(err))
        }
        )
    }    
}

export function startLoadingFeeSummary(){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getAdviserFeeSummary`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json();
                else 
                    return{status: response.status, message: response.statusText}
            })
            .then(response => dispatch(getAdviserFeeSummary(response.advisers)))
            .catch(err => console.log(err))
        }
        )
    }    
}

export function startLoadingMembers(id){
    if(!id || id===-1)
        id = ""
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getMemberList?adviserId=${id}`, authorizationHeader(keycloak.refreshToken))
        .then(response => {
            if (response.status === 200){
                return response.json();
            }
            else
                return { status: response.status, message: response.statusText }
        })
        .then(response => response.memberList)
        .then(memberList => dispatch(getMemberList(memberList)))
        .catch(err => console.log(err))
        })
    }
}


export function startLoadingMemberDetails(id){
    return (dispatch) => {
       keycloak.updateToken(120).success(() => {
        return fetch(`${apiHost}/adv/rest/getMember?usrMemberSetId=${id}`, authorizationHeader())
        .then(response => {
            if(response.status === 200)
                return response.json();
            else
                return {status: response.status, message: response.statusText}
        })
        .then(response => response.member)
        .then(member => dispatch(getMemberDetails(member)))
        .catch(err => console.log(err))
       })
    }
}

export function startLoadingMemberContribution(id){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
         return fetch(`${apiHost}/adv/rest/getMemberContribution?usrMemberSetId=${id}`, authorizationHeader())
         .then(response => {
             if(response.status === 200)
                 return response.json();
             else
                 return {status: response.status, message: response.statusText}
         })
         .then(response => response.memberContribution)
         .then(memberContribution => dispatch(getMemberContributions(memberContribution)))
         .catch(err => console.log(err))
        })
     }
}

export function startLoadingCommissions(startDate){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getCommissions?startDate=${startDate}`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json();
                else
                    return {status: response.status, message: response.statusText}
            })
            .then(response => response.commissions)
            .then(commissions => dispatch(getCommissions(commissions)))
            .catch(err => console.log(err))
        })
    }
}

export function startLoadingAccountBalances(usrMemberSetId, startDate, endDate, period, prevProps){
    return (dispatch) => {
       keycloak.updateToken(120).success(() => {
        return fetch(`${apiHost}/adv/rest/getMemberAccounts?usrMemberSetId=${usrMemberSetId}&startDate=${startDate}&endDate=${endDate}`, authorizationHeader())
        .then(response => {
            if(response.status === 200)
                return response.json();
            else
                return {status: response.status, message: response.statusText}
        })
        .then(response => (response))
        .then(accountBalances => dispatch(getAccountBalances(accountBalances.empty, accountBalances.balances, accountBalances.products, accountBalances.returns, period, prevProps)))
        .catch(err => console.log(err))
       })
    }
}

export function startLoadingFundBalances(usrMemberSetId, startDate, endDate, accounts, funds){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getMemberFunds?usrMemberSetId=${usrMemberSetId}&startDate=${startDate}&endDate=${endDate}&accounts=${accounts}&funds=${funds}`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json();
                else
                    return {status: response.status, message: response.statusText}
            }).then(response => response)
            .then(fundBalances => dispatch(getFundBalances(fundBalances.empty, fundBalances.balances, fundBalances.funds)))
            .catch(err => console.log(err))
        })
    }
}

export function startLoadingTransactions(usrMemberSetId, startDate, endDate){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getMemberTransactions?usrMemberSetId=${usrMemberSetId}&startDate=${startDate}&endDate=${endDate}&type=F`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json();
                else   
                    return {status: response.status, message: response.statusText}
            }).then(response => response)
            .then(transactions => dispatch(getMemberTransactions(transactions.empty, transactions.transactions)))
            .catch(err => console.log(err))
        })
    }
}

export function startLoadingAccountReturns(usrMemberSetId, startDate, endDate){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getMemberAccountReturns?usrMemberSetId=${usrMemberSetId}&startDate=${startDate}&endDate=${endDate}`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json()
                else
                    return {status: response.status, message: response.statusText}
            }).then(response => response)
            .then(accountReturns => dispatch(getAccountReturns(accountReturns.empty, accountReturns.returns)))
            .catch(err => console.log(err))
        })
    }
}

export function startLoadingFundReturns(usrMemberSetId, startDate, endDate, accounts, funds){
    return (dispatch) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/getMemberFundReturns?usrMemberSetId=${usrMemberSetId}&startDate=${startDate}&endDate=${endDate}&accounts=${accounts}&funds=${funds}`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json();
                else  
                    return {status: response.status, message: response.statusText}
            }).then(response => response)
            .then(fundReturns => dispatch(getFundReturns(fundReturns.empty, fundReturns.returns)))
            .catch(err => console.log(err))
        })
    }
}


export function startDownloadingTransactionsCSV(usrMemberSetId, startDate, endDate){
    return (dispatch) => {
        return new Promise((resolve, reject) => {
        keycloak.updateToken(120).success(() => {
            return fetch(`${apiHost}/adv/rest/downloadMemberTransactionsCSV?usrMemberSetId=${usrMemberSetId}&startDate=${startDate}&endDate=${endDate}`, authorizationHeader())
            .then(response => {
                if(response.status === 200)
                    return response.json();
                else   
                    return {status: response.status, message: response.statusText}
            }).then(transactions => {dispatch(downloadTransactionsCSV(transactions.header, transactions.details));resolve()})
            .catch(err => {console.log(err); reject()})
        })
    })
    }
}

export function startLoadingMemberFutureStrategy(usrMemberSetId){
    return (dispatch) => {
       keycloak.updateToken(120).success(() => {
        return fetch(`${apiHost}/adv/rest/getMemberFutureStrategy?usrMemberSetId=${usrMemberSetId}`, authorizationHeader())
        .then(response => {
            if(response.status === 200)
                return response.json();
            else return {status: response.status, message: response.statusText}
        }).then(futureStrategy => dispatch(getMemberFutureStrategy(futureStrategy)))
        .catch(err => console.log(err))
       })
    }
}

export function startLoadingLabels(codes, usrMemberSetId){
    return (dispatch) => {
       keycloak.updateToken(120).success(() => {
        return fetch(`${apiHost}/adv/rest/getLabels?codes=${codes}&usrMemberSetId=${usrMemberSetId}`)
        .then(response => {
            if(response.status === 200)
                return response.json();
            else return {status: response.status, message: response.statusText}
        }). then(label => dispatch(getLabels(label)))
        .catch(err => console.log(err))
       })
    }
}

export function filterFundsByAccounts(accounts){
    return (dispatch) => dispatch(getAccounts(!accounts ? "" : accounts))
}

export function filterFundsByFunds(funds){
    return (dispatch) => dispatch(getFunds(!funds ? "" : funds))
}

export function setSelectedAdviserId(id){
    return (dispatch) => dispatch(getSelectedAdviserId(!id ? "" : id))
}

export function keycloakLogin(keycloak, authenticated){
    return{
        type: 'KEYCLOAK_LOGIN',
        keycloak,
        authenticated
    }
}
    
export function getAdvisers(advisers, total, groupLogin, lastLoginDate){
    return{
        type: 'GET_ADVISERS',
        advisers,
        total,
        groupLogin,
        lastLoginDate
    }
}

export function getAdviserFeeSummary(fees){
    return{
        type: 'GET_ADVISER_FEE_SUMMARY',
        fees
    }
}

export function getSelectedAdviserId(id){
    return {
        type: 'GET_SELECTED_ADVISER_ID',
        id
    }
}

export function getMemberList(memberList){
    return{
        type: 'GET_MEMBER_LIST',
        memberList
    }
}

export function getMemberDetails(member){
    return{
        type: 'GET_MEMBER_DETAILS',
        member
    }
}

export function getMemberContributions(memberContribution){
    return{
        type: 'GET_MEMBER_CONTRIBUTIONS',
        memberContribution
    }
}

export function getCommissions(commissions){
    return{
        type: 'GET_COMMISSION_DETAILS',
        commissions
    }
}

export function getAccountBalances(empty, accountBalances, products, accountReturns, period, prevProps){
    return{
        type: 'GET_ACCOUNT_BALANCES',
        empty,
        accountBalances,
        products,
        accountReturns,
        period,
        prevProps
    }
}

export function getFundBalances(empty, fundBalances, totalFunds){
    return {
        type: 'GET_FUND_BALANCES',
        empty,
        fundBalances,
        totalFunds
    }
}

export function getAccounts(accounts){
    return {
        type: 'GET_ACCOUNTS',
        accounts
    }
}

export function getFunds(funds){
    return {
        type: 'GET_FUNDS',
        funds
    }
}

export function getAccountReturns(empty, accountReturns){
    return {
        type: 'GET_ACCOUNT_RETURNS',
        empty,
        accountReturns
    }
}

export function getFundReturns(empty, fundReturns){
    return{
        type: 'GET_FUND_RETURNS',
        empty,
        fundReturns
    }
}

export function getMemberTransactions(empty, transactions){
    return {
        type: 'GET_MEMBER_TRANSACTIONS',
        empty,
        transactions
    }
}

export function downloadTransactionsCSV(transactionsHeader, transactionsDetails){
    return {
        type: 'DOWNLOAD_TRANSACTIONS_CSV',
        transactionsHeader,
        transactionsDetails
    }
}

export function getMemberFutureStrategy(futureStrategy){
    return {
        type: 'GET_FUTURE_STRATEGY',
        futureStrategy
    }
}

export function getLabels(labelText){
    return {
        type: 'GET_LABELS',
        labelText
    }
}